import gql from 'graphql-tag';

export const UPDATE_USER_FILTER = gql`
  mutation updateUserFilter($filter: UserFilterInput!, $orderBy: [String], $pagination: UserPaginationInput) {
    updateUserFilter(filter: $filter, orderBy: $orderBy, pagination: $pagination) @client
  }
`;
